import {
	Component,
	DoCheck,
	ElementRef,
	EventEmitter,
	forwardRef,
	Injector,
	Input,
	Output,
	ViewChild
} from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { noop } from 'rxjs';
import { ValidatorCheck } from '../../utils/validator.check';

export const INPUT_VALUE_ACCESSOR_DATEPICKER: any = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => InputDatepickerComponent),
	multi: true
};

@Component({
    selector: 'pim-input-datepicker',
    templateUrl: './input.datepicker.component.html',
    providers: [INPUT_VALUE_ACCESSOR_DATEPICKER],
    standalone: false
})
export class InputDatepickerComponent implements ControlValueAccessor, DoCheck {
	@Input()
	id!: string;
	@Input()
	label: string = '';

	@Output()
	dateChange: EventEmitter<void> = new EventEmitter<void>();

	required: boolean = false;

	@ViewChild('input', {static: false})
	input!: ElementRef;

	private internalValue: any = '';

	private onChangeCallback: (_: any) => void = noop;

	control!: UntypedFormControl;

	constructor(private injector: Injector, private validatorCheck: ValidatorCheck) {
	}

	ngDoCheck(): void {
		this.checkControlValidators();
	}

	// Datepicker Auswahl über das Pop-Up ziehen den Fokus aus dem Form -> FormEnter geht nicht mehr
	focusInput(): void {
		this.input.nativeElement.focus();
	}

	dateChanged(): void {
		this.dateChange.emit();
	}

	get fullLabel(): string {
		const requiredAstersik = this.required ? ' *' : '';
		return `${this.label}${requiredAstersik}`;
	}

	get value(): any {
		return this.internalValue;
	}

	set value(v: any) {
		if (v !== this.internalValue) {
			this.internalValue = v;
			this.onChangeCallback(v);
		}
	}

	checkControlValidators(): void {
		this.control = this.injector.get(NgControl).control as UntypedFormControl;
		if (this.control === undefined) {
			this.control = new UntypedFormControl();
		}

		this.required = this.validatorCheck.isRequired(this.control);
	}

	writeValue(obj: any): void {
		if (this.value !== obj) {
			this.value = obj;
		}
	}

	registerOnChange(fn: any): void {
		this.onChangeCallback = fn;
	}

	registerOnTouched(): void {
	}
}
